import { configureStore } from "@reduxjs/toolkit";
import blogsReducer from "../features/Blogs/blogsSlice";
import blogDetailsReducer from "../features/BlogDetails/blogDetailsSlice";

export const store = configureStore({
  reducer: {
    blogs: blogsReducer,
    blogsDetails: blogDetailsReducer,
  },
});
